import { highlightsUrlToCategory } from 'shared/helpers/eismo';

export default (categories = {}) =>
  Object.entries(categories).reduce(
    (acc, [url, label]) => ({ ...acc, [highlightsUrlToCategory(url)]: label }),
    {}
  );
